export const initCategoryShowcase = (): void => {
  const sliders = document.querySelectorAll<HTMLElement>(
    ".category-showcase__swiper",
  );

  if (sliders.length === 0) return;

  // 1. Güvenli Obje Çıkarma (Swiper is not a constructor hatasını çözer)
  const rawSwiper = window.EcommerceCore.vendors.Swiper;
  const SwiperClass = (rawSwiper as any).default || rawSwiper;

  // 2. Modülleri al
  const { Pagination, Navigation } = window.EcommerceCore.vendors.SwiperModules;

  sliders.forEach((sliderElement) => {
    if (sliderElement.dataset.initialized === "true") return;
    sliderElement.dataset.initialized = "true";

    const wrapper = sliderElement.closest(".category-showcase__grid-wrapper");

    // 3. new Swiper() yerine new SwiperClass() kullanarak başlatıyoruz
    new SwiperClass(sliderElement, {
      modules: [Pagination, Navigation],
      slidesPerView: 1, // PHP tarafında zaten 4'lü paketlere (chunk) böldüğümüz için 1 tam slide yeterli
      spaceBetween: 30,
      autoHeight: true, // Grid satır sayısı azaldığında yüksekliği tolere etmesi için
      observer: true, // EKLENDİ: Sayfa yüklendikten sonraki DOM değişimlerini algılar
      observeParents: true, // EKLENDİ: Üst kapsayıcı değişimlerini algılar
      pagination: {
        el: wrapper?.querySelector(".swiper-pagination") as HTMLElement,
        clickable: true,
      },
      navigation: {
        nextEl: wrapper?.querySelector(".swiper-button-next") as HTMLElement,
        prevEl: wrapper?.querySelector(".swiper-button-prev") as HTMLElement,
      },
    });
  });

  console.log("[CategoryShowcase] Swiper Initialized.");
};
